import React from "react"
import Skeleton from "../../components/Common/Skeleton"

const initialsFromName = (name = "") =>
  String(name)
    .replace(/[—–-]/g, " ")
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map(part => part[0]?.toUpperCase())
    .join("")

const ProfilePhoto = ({
  src,
  name = "",
  alt,
  loading = false,
  className = "",
}) => {
  const label = alt || name || "Profile photo"

  if (loading && !src) {
    return <Skeleton className={className} />
  }

  if (src) {
    return <img src={src} alt={label} className={className} />
  }

  return (
    <span className={`${className} profile-photo-fallback`} aria-label={label}>
      {initialsFromName(name)}
    </span>
  )
}

export default ProfilePhoto
